import { render, staticRenderFns } from "./AssessmentQuestions.vue?vue&type=template&id=d45797f4&scoped=true"
import script from "./AssessmentQuestions.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45797f4",
  null
  
)

export default component.exports